import { Table } from '@factorialco/deprecated-design-system'

export const Gap = ({ colSpan }: { colSpan: number }) => {
  return (
    <Table.Row>
      <Table.Cell wide colSpan={colSpan} style={{ height: '8px', padding: '0px' }} />
    </Table.Row>
  )
}
